import React, { useEffect, useState } from 'react';
import Wrapper from "../components/Wrapper.js";
import { Col, Row } from "react-bootstrap";
import { Link } from "react-router";
import Api from "../Api.js";
import FlipCameraAndroidIcon from '@mui/icons-material/FlipCameraAndroid';
import CustomizedRatings from '../components/Agents/CustomizedRatings.js';
import DeleteIcon from '@mui/icons-material/Delete';
import { ModalCheckboxPicker } from '../components/Agents/ModalCheckboxPicker.js';
import { useSelector } from 'react-redux';
function StaffList(props) {
    const [types, setTypes] = useState([]);
    const [agents, setAgents] = useState([]);
    const [allowed, setAllowed] = useState([]);
    const login = useSelector((state) => state.manager.employee);
    const isAdmin = login?.user_id === 86 || login?.user_id === 1734 || login?.user_id === 2;

    const handleDelete = async (id) => {
        try {
            let text = "Վստա՞հ եք, որ ցանկանում եք ջնջել";

            if (confirm(text) === true) {
                await Api.deleteAgentTaskAllow(id)
                useState(prev => ([prev.filter(l => l.id !== id)]))
            }
        } catch (e) {

        }
    }
    const account = useSelector((state) => state.task.accountant);
    const managers = useSelector((state) => state.task.managers);
    const getDate = async () => {
        try {
            const { data: alloweds } = await Api.getAgentTaskAllow()
        setAllowed(alloweds)
        } catch (error) {
            
        }
        
    }
    const isManager = login?.user_id === 86 || login?.user_id === 414 || login?.user_id === 2 || login?.user_id === 1734 || false

    useEffect(() => {
        (async () => {
            try {
                
                const { data } = await Api.getStuff()
                setTypes(data.results)
                await getDate()
                
                // Fetch agents if user is a manager
                const currentIsManager = login?.user_id === 86 || login?.user_id === 414 || login?.user_id === 2 || login?.user_id === 1734
                if (currentIsManager) {
                    const { data: agent } = await Api.gerAgentList()
                    setAgents(agent)
                }
            } catch (e) {
                console.log(e)
            }
        })()
    }, [login?.user_id]);
    console.log(isManager);
    
    return (
        <Wrapper>
            <div className='w-100'>
                <Row className='manager-stuff'>
                    <div className="d-flex align-items-center justify-content-end">
                        <Link to="/main_employee/team" className="change_team"><FlipCameraAndroidIcon /></Link>
                    </div>
                    {types?.map((item, index) => (
                        <Col sm={4} xs={6} key={index}>
                            <Link to={`/main_employee/staff/${item.id}`}>
                                <img className="staff-type" src={item.image} alt="Staff Type" />
                            </Link>
                        </Col>
                    ))}
                </Row>

                {isManager ? <div>
                    <div style={{marginBottom:30}}>
                        <ModalCheckboxPicker
                            items={[...account, ...managers].map(i => ({
                                id: i.user_id,
                                label: `${i.user?.first_name ?? ""} ${i.user?.last_name ?? ""}`.trim(),
                            }))}
                            initialSelected={allowed.map(i => i.user.id)}
                            onCreate={async (userId) => {
                                await Api.createAgentTaskAllow({ user_id: userId, can_add: true, can_view: true });
                            }}
                            onDelete={async (userId) => {
                                const row = allowed.find(a => a.user?.id === userId);
                                if (row) await Api.deleteAgentTaskAllow(row.id);
                            }}
                            onConfirm={async (ids) => {
                                await getDate()
                            }}
                        />


                    </div>

                    <Row className='manager-stuff'>

                        {allowed.map((l, index) => (
                            <Col sm={4} xs={4} key={index}>
                                <div className='agent d-flex justify-content-between'>
                                    <span>{l.user?.first_name} {l.user?.last_name}</span>
                                    <span onClick={() => handleDelete(l.id)}><DeleteIcon /></span>
                                </div>
                            </Col>))}
                    </Row>
                </div>
                    : null}
                {isManager ? <div><h3>Գործակալներ</h3></div> : null}
                {isManager?<Row className='manager-stuff'>
                    {agents.length ? agents.map((a, index) => (
                        <Col sm={4} xs={6} key={index}>
                            <div className='agent'>{a.user?.first_name} {a.user?.last_name}</div>
                            <div className='agent d-flex align-item-center justify-content-between'><CustomizedRatings className="m-0" defaultValue={(
                                a.reviews?.map(r => r.rating).reduce((a, b) => a + b, 0) / a.reviews.length
                            ).toFixed(1)} />
                                {a.reviews.length ? (
                                    a.reviews.map(r => r.rating).reduce((a, b) => a + b, 0) / a.reviews.length
                                ).toFixed(1) : "Չգնահատված"}
                            </div>

                        </Col>
                    )) : ""}
                </Row>:null}

            </div>
        </Wrapper>
    );
}

export default StaffList;